import buildPromotions from 'redux/transforms/build-promotions';
import transformBasketBuilderSuggestionsIntoLegacyFormat from 'redux/transforms/transform-basket-builder-suggestions-into-legacy-format';
import mapProductsIntoLegacyFormat from 'redux/transforms/transform-product-into-legacy-format';
import mapProductsAndRecommendationsIntoLegacyFormat from 'redux/transforms/transform-products-and-recommendations-into-legacy-format';
import transformGridItems from 'redux/transforms/transform-grid-items';
import transformInterstitialsContent from 'redux/transforms/transform-interstitials-content';
import transformIntelligentShoppingExperienceSuggestionsIntoLegacyFormat from 'redux/transforms/transform-intelligent-shopping-suggestions-into-legacy-format';

export const BUILD_PROMOTIONS = 'buildPromotions';
export const TRANSFORM_BASKET_BUILDER_SUGGESTIONS_INTO_LEGACY_FORMAT =
  'transformBasketBuilderSuggestionsIntoLegacyFormat';
export const TRANSFORM_GRID_ITEMS = 'transformGridItems';
export const TRANSFORM_INTERSTITIALS_CONTENT = 'transformInterstitialsContent';
export const TRANSFORM_PRODUCTS_INTO_LEGACY_FORMAT = 'mapProductsIntoLegacyFormat';
export const TRANSFORM_PRODUCTS_AND_RECOMMENDATIONS_INTO_LEGACY_FORMAT =
  'mapProductsAndRecommendationsIntoLegacyFormat';
export const TRANSFORM_INTELLIGENT_SHOPPING_EXPERIENCE_SUGGESTIONS_INTO_LEGACY_FORMAT =
  'transformIntelligentShoppingExperienceSuggestionsIntoLegacyFormat';

export const transforms = {
  buildPromotions,
  transformBasketBuilderSuggestionsIntoLegacyFormat,
  mapProductsIntoLegacyFormat,
  mapProductsAndRecommendationsIntoLegacyFormat,
  transformGridItems,
  transformInterstitialsContent,
  transformIntelligentShoppingExperienceSuggestionsIntoLegacyFormat,
};
